import { render, staticRenderFns } from "./uploadWork.vue?vue&type=template&id=9dfad518&scoped=true&"
import script from "./uploadWork.vue?vue&type=script&lang=js&"
export * from "./uploadWork.vue?vue&type=script&lang=js&"
import style0 from "./uploadWork.vue?vue&type=style&index=0&id=9dfad518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfad518",
  null
  
)

export default component.exports